<div [formGroup]="incidentFilterForm" class="main-container">
	<mat-form-field style="margin-right: 20px; width: 320px">
		<mat-label>IRWIN ID</mat-label>
		<input matInput formControlName="irwinId" />
		<mat-error *ngIf="incidentFilterForm.controls.irwinId?.hasError('invalidIrwinId')">
			Irwin id must be in the UUID format (EAA18302-B6C2-49C0-9332-B04A58C3CEC5)
		</mat-error>
	</mat-form-field>
	<div class="label">-OR-</div>
	<div class="details-container">
		<div>
			<mat-form-field class="incidentDetails">
				<mat-label>Incident Name</mat-label>
				<input matInput formControlName="incidentName" />
			</mat-form-field>
			<mat-form-field class="incidentDetails range-dropdown">
				<mat-label>Incident Size</mat-label>
				<mat-select formControlName="incidentSizeType">
					<mat-option *ngFor="let numberRange of numberRangeLOV" [value]="numberRange.value">{{ numberRange.label }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div style="display: flex; flex-direction: column">
			<div>
				<mat-form-field class="incidentDetails">
					<mat-label>Acres</mat-label>
					<input matInput type="number" formControlName="startSize" />
				</mat-form-field>
			</div>
			<div *ngIf="incidentFilterForm.get('incidentSizeType')?.value === 'Between'" class="and">and</div>
			<div *ngIf="incidentFilterForm.get('incidentSizeType')?.value === 'Between'" class="finalNumber">
				<mat-form-field class="incidentDetails">
					<mat-label>Acres</mat-label>
					<input matInput type="number"  formControlName="endSize" />
				</mat-form-field>
			</div>
		</div>
		<div>
			<mat-form-field class="incidentDetails range-dropdown">
				<mat-label>Estimated Final Cost</mat-label>
				<mat-select formControlName="estimatedFinalCostType">
					<mat-option *ngFor="let numberRange of numberRangeLOV" [value]="numberRange.value">{{ numberRange.label }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		<div>
			<div>
				<mat-form-field class="incidentDetails">
					<mat-label>Dollars</mat-label>
					<input matInput id="estimatedFinalCost" wfdssCurrencyFormat formControlName="finalCost" />
				</mat-form-field>
				<div *ngIf="incidentFilterForm.get('estimatedFinalCostType')?.value === 'Between'" class="and">and</div>
				<div *ngIf="incidentFilterForm.get('estimatedFinalCostType')?.value === 'Between'" class="finalNumber">
					<mat-form-field class="incidentDetails">
						<mat-label>Dollars</mat-label>
						<input matInput id="estimatedFinalCost" formControlName="finalCostEnd" wfdssCurrencyFormat />
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>

	<div>
		<span class="label"> Filters </span>
	</div>
	<div style="display: flex; flex-direction: row">
		<div *ngFor="let dateFilterOption of dateFilterOptions" style="display: flex; flex-direction: row; margin-bottom: 25px; margin-right: 52px">
			<div>
				<mat-radio-group
					color="primary"
					style="display: flex; flex-direction: column; margin-right: 32px"
					class="flex-radio-group"
					[formControlName]="dateFilterOption.mainFormControlName"
					[attr.aria-label]="dateFilterOption.labelForRestricted"
					(change)="radioSelectionChange()">
					<mat-radio-button [value]="dateFilterOption.mainFormControlName">
						{{ dateFilterOption.labelForAny }}
					</mat-radio-button>
					<mat-radio-button class="radio-option" [value]="dateFilterOption.labelForRestricted">
						{{ dateFilterOption.labelForRestricted }}
					</mat-radio-button>
					<mat-radio-button *ngIf="!!dateFilterOption?.labelForNoDate" class="radio-option" [value]="dateFilterOption?.labelForNoDate">
						{{ dateFilterOption.labelForNoDate }}
					</mat-radio-button>
				</mat-radio-group>
			</div>

			<div style="display: flex; flex-direction: row; align-items: center">
				<mat-form-field style="margin-left: 14px; width: 7.5rem; margin-right: 16px">
					<mat-select [formControlName]="dateFilterOption.rangeFormControlName">
						<mat-option *ngFor="let dateRangeValue of dateRangeValues" [value]="dateRangeValue">{{ dateRangeValue }}</mat-option>
					</mat-select>
				</mat-form-field>
				<div style="margin-left: 5px">
					<mat-form-field>
						<input matInput [matDatepicker]="datePicker" [formControlName]="dateFilterOption.lowerDateFormControlName" />
						<mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
						<mat-datepicker #datePicker></mat-datepicker>
					</mat-form-field>
					<div *ngIf="incidentFilterForm.controls[dateFilterOption.rangeFormControlName].value === 'Between'" style="margin-bottom: -43px">
						<div class="and">and</div>
						<mat-form-field style="margin-bottom: 18px">
							<input matInput [matDatepicker]="datePicker" [formControlName]="dateFilterOption.upperDateFormControlName" />
							<mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
							<mat-datepicker #datePicker></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
			</div>
		</div>
		<div class="checkbox-container">
			<mat-checkbox color="primary" style="margin-bottom: 16px" formControlName="publishedDecision"> Incident has Published Decision </mat-checkbox>
			<mat-checkbox color="primary" formControlName="completedAnalysis"> Incident has Completed Analysis </mat-checkbox>
		</div>
	</div>
	<div>
		<div class="geographic-area">
			<div>
				<mat-form-field style="margin-right: 20px">
					<mat-label>Geographic Area</mat-label>
					<mat-select formControlName="selectedGeographicAreaId">
						<mat-option [value]="-1">No Selection</mat-option>
						<mat-option *ngFor="let geographicArea of geographicAreas" [value]="geographicArea.id">{{ geographicArea.geographicAreaName }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="margin-right: 16px">
					<mat-label>State</mat-label>
					<mat-select formControlName="selectedState">
						<mat-option [value]="'-1'">No Selection</mat-option>
						<mat-option *ngFor="let state of statesPickList" [value]="state.code">{{ state.name }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="margin-right: 20px">
					<mat-label>Jurisdictional Agency</mat-label>
					<mat-select formControlName="selectedAgencyId">
						<mat-option [value]="-1">No Selection</mat-option>
						<mat-option *ngFor="let agency of agencies" [value]="agency.id">{{ agency.agency }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div>
				<mat-form-field style="width: 400px; margin-right: 16px">
					<mat-label>Jurisdictional Unit</mat-label>

					<mat-select multiple formControlName="selectedJurisditionalUnitIds">
						<mat-option [value]="-1">No Selection</mat-option>
						<mat-option *ngFor="let unit of jurisdictionalUnits" [value]="unit.unitId" [disabled]="noJurisdictionSelection"
							>{{ unit.unitId }} - {{ unit.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>

				<!-- TODO: For typeahead feature for jurisdictional units -->
				<!-- <mat-form-field style="width: 400px; margin-right: 16px;">
          <mat-label>Jurisdictional Unit</mat-label>
          <input type="text" placeholder="Enter Search Text" aria-label="Enter Search Text" matInput [matAutocomplete]="auto" [formControl]="jdtnSearchControl">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option [value]="-1">
                <div>
                    <mat-checkbox (click)="$event.stopPropagation()" [disabled]="noJurisdictionSelection">
                        No Selection
                    </mat-checkbox>
                </div>
            </mat-option>
            <mat-option *ngFor="let each of filteredJdtnUnits$ | async" [value]="each.unitId">
                <div>
                    <mat-checkbox (click)="$event.stopPropagation()" [disabled]="noJurisdictionSelection">
                        {{ each.name }}
                    </mat-checkbox>
                </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field> -->

				<div *ngIf="selectedJurisdictionalUnits.length > 0">Selected Units</div>
				<ul *ngIf="selectedJurisdictionalUnits.length > 0" style="max-height: 200px; overflow: auto; background-color: #fafafa">
					<li *ngFor="let unit of selectedJurisdictionalUnits">{{ unit.unitId }} - {{ unit.name }}</li>
				</ul>
			</div>

			<div>
				<mat-form-field style="width: 400px">
					<mat-label>Protecting Unit</mat-label>
					<mat-select multiple formControlName="selectedProtectingUnitIds">
						<mat-option [value]="-1">No Selection</mat-option>
						<mat-option *ngFor="let unit of protectingUnits" [value]="unit.unitId" [disabled]="noProtectingUnitSelection"
							>{{ unit.unitId }} - {{ unit.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
				<div *ngIf="selectedProtectingUnits.length > 0">Selected Units</div>
				<ul *ngIf="selectedProtectingUnits.length > 0" style="max-height: 200px; overflow: auto; background-color: #fafafa">
					<li *ngFor="let unit of selectedProtectingUnits">{{ unit.unitId }} - {{ unit.name }}</li>
				</ul>
			</div>
		</div>
	</div>
	<!-- [disabled]="!incidentFilterForm.valid"> -->
	<button class="primary-button" (click)="onSearch()">Search</button>
</div>

<div id="li-table" style="margin: 0px 30px">
	<wfdss-configurable-mat-table
		[showExport]="true"
		[displayPointerOnHover]="true"
		[exportPrefix]="'SearchResults'"
		[exportSuffix]="'LegacyIncidentData'"
		[dataSource]="legacyIncidentDataSource"
		[columnMetaInformationIn]="legacyIncidentDisplayConfig"
		[sortActive]="sortActive"
		[downloadCSVExportDataAccessor]="CSVExportDataAccessor"
		[sortDirection]="sortDirection"
		[sortingDataAccessor]="sortingDataAccessor"></wfdss-configurable-mat-table>
</div>
